<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 本页标题 -->
            <div class="banner_title">综合评价</div>

            <!-- 企业介绍 -->
            <a-row justify="space-between" class="mg_t">
                <a-col :span="4" class="title">
                    {{PdftStore.fromData.orgInfo?.orgName}}介绍
                </a-col>
                <a-col :span="19" class="txt">
                    {{PdftStore.fromData.orgInfo?.introduction}}
                </a-col>
            </a-row>

            <!-- 评价结果 -->
            <a-row justify="space-between" align="bottom" class="mg_t">
                <a-col :span="4" class="title mgB">
                    评价结果
                </a-col>
                <a-col :span="19">
                    <a-row justify="space-between" align="bottom">
                        <!-- 青铜表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 1 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 1">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">青铜</div>
                            <div class="fd font-s">{{'<'+50}}</div>
                            <div class="fd font-s">一般表现</div>
                        </a-col>

                        <!-- 白银表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 2 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 2">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">白银</div>
                            <div class="fd font-s">51 ~ 60</div>
                            <div class="fd font-s">一般表现</div>
                        </a-col>

                        <!-- 黄金表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 3 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 3">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">黄金</div>
                            <div class="fd font-s">61 ~ 70</div>
                            <div class="fd font-s">非常优秀</div>
                        </a-col>

                        <!-- 白金表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 4 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 4">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">白金</div>
                            <div class="fd font-s">71 ~ 85</div>
                            <div class="fd font-s">顶级表现</div>
                        </a-col>

                        <!-- 钻石表现 -->
                        <a-col :class="PdftStore.fromData.questionnaireInfo?.grade == 5 ? 'heightBox' : 'box'">
                            <div class="nametxt" v-show="PdftStore.fromData.questionnaireInfo?.grade == 5">
                                <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                            </div>
                            <div class="fd mg_tx">钻石</div>
                            <div class="fd font-s">86 ~ 100</div>
                            <div class="fd font-s">最高表现</div>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>

            <!-- 评价总览 -->
            <a-row justify="space-between" class="mg_T">
                <a-col :span="4" class="title">
                    评价总览
                </a-col>
                <a-col :span="19" class="txt">
                    {{PdftStore.fromData.questionnaireInfo?.overview}}
                </a-col>
            </a-row>

            <!-- 得分详情 -->
            <a-row class="list" align="middle">

                <!-- 总分 -->
                <a-col class="mg_r">
                    <a-progress type="circle" :width="170" strokeColor="#00baf4" :percent="PdftStore.fromData.questionnaireInfo?.score">
                        <template #format="percent">
                            <span style="color:#013C89;font-size: 72px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                </a-col>

                <!-- 运营排放 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionOperational?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">运营排放</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionOperational?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionOperational?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 产业链排放 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndustrialChain?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">产业链排放</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionIndustrialChain?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionIndustrialChain?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 直接减排贡献 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionDirectReduction?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">直接减排贡献</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionDirectReduction?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionDirectReduction?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 间接减排贡献 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndirectReduction?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">间接减排贡献</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionIndirectReduction?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionIndirectReduction?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 零碳运营 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroOperation?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">零碳运营</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionZeroOperation?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionZeroOperation?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 绿色供应链 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionGreenSupply?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">绿色供应链</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionGreenSupply?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionGreenSupply?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 承诺与披露 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionPromise?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">承诺与披露</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionPromise?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionPromise?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

                <!-- 零碳投资 -->
                <a-col class="list_r">
                    <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroInvestment?.updateScore">
                        <template #format="percent">
                            <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                        </template>
                    </a-progress>
                    <div class="list_b">
                        <div class="flex">
                            <div class="t">零碳投资</div>
                            <div class="t_m">{{PdftStore.fromData.spaceEmissionZeroInvestment?.weightScore || 0}}</div>
                        </div>
                        <div class="flex mg_top_list">
                            <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionZeroInvestment?.weight}}%</div>
                            <div class="s_j"></div>
                        </div>
                    </div>
                </a-col>

            </a-row>

            <!-- 表格和logo -->
            <div class="flexbox">
                <div class="charts">
                    <Echarts v-if="PdftStore.fromData.questionnaireInfo" :name="'page4echarts'"/>
                </div>
                <div class="logobox">
                    <Logos :ids="'arctext5'"/>
                    <div class="logoboxtxt">
                        <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                    </div>
                </div>
            </div>

            <!-- 企业详细 -->
            <div class="txt_box">{{PdftStore.fromData.questionnaireInfo?.evaluate}}</div>
            <!-- <div class="txt_box1">{{PdftStore.fromData.questionnaireInfo?.conclusion}}</div> -->
            

            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">02</div>
        </div>
        
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Logos from '../components/logos.vue'
import Bottoms from '../components/bottoms.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page4',
    components:{Headers, Logos, Bottoms, Echarts},
    setup() {
        const data = reactive({
            num:33,
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .banner_title{
            padding: 96px 0 40px 0;
            font-size: 72px;
            font-weight: bold;
            color: #013C89;
            line-height: 100px;
            border-bottom: 2px solid #013C89;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .mg_t{
            margin-top: 50px;
        }
        .mg_top{
            margin-top: 123px;
        }
        .title{
            font-size: 28px;
            font-weight: bold;
            color: #013C89;
            line-height: 45px;
        }
        .mgB{
            margin-bottom: 45px;
        }
        .mg_T{
            margin-top: 80px;
        }
        .txt{
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            text-align: justify;
            white-space: normal;
            word-wrap: break-word;
        }
        .box{
            width: 169px;
            height: 130px;
            background: #FFFFFF;
            border: 3px solid #F3F3F3;
            border-bottom: 8px solid #D9DADA;
            text-align: center;
            padding-top: 20px;
            .fd{
                font-size: 24px;
                font-weight: 400;
                color: #666666;
                line-height: 30px;
            }
            .font-s{
                font-size: 18px;
                font-weight: 400;
            }
        }
        .heightBox{
            width: 169px;
            height: 195px;
            background: #FFFFFF;
            border: 3px solid #F3F3F3;
            border-bottom: 8px solid #013C89;
            padding: 24px 39px;
            .logo{
                width: 88px;
                height: 30px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .mg_tx{
                margin-top: 29px;
            }
            .fd{
                font-size: 24px;
                font-weight: 400;
                color: #013C89;
                line-height: 30px;
                text-align: center;
            }
            .font-s{
                font-size: 18px;
                font-weight: 400;
            }
        }
        .list{
            margin-top: 30px;
            width: 100%;
            height: 220px;
            border-top: 1px solid #C5C5C6;
            border-bottom: 1px solid #C5C5C6;
        }
        .mg_r{
            margin-right: 65px;
        }
        .list_r{
            width: 109px;
            margin: 0 9px;
            height: 100%;
            padding: 40px 0;
            text-align: center;
            .list_b{
                padding-top: 12px;
                margin-top: 10px;
                border-top: 2px solid #322523;
                .mg_top_list{
                    padding-top: 12px;
                }
                .flex{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .t{
                        font-size: 12px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 17px;
                    }
                    .t_m{
                        font-size: 14px;
                        font-weight: 600;
                        color: #013C89;
                        line-height: 17px;
                    }
                    .t_a{
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 17px;
                    }
                    .s_j{
                        margin-right: 3px;
                        width:0;
                        height:0;
                        border-left:5.5px solid transparent;
                        border-right:5.5px solid transparent;
                        border-bottom:11px solid #013C89;
                    }
                    
                }
            }
        }
        .flexbox{
            display: flex;
            align-items: center;
            padding: 20px 0;
            border-bottom: 1px solid #C5C5C6;
            .charts{
                width: 760px;
                height: 440px;
                padding-right: 160px;
                border-right: 1px dashed #C5C5C6;
            }
            .logobox{
                margin: 0 auto;
                .img_box{
                    width: 250px;
                    height: 85px;
                    margin: 0;
                    margin-top: 66px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
        .txt_box{
            margin-top: 36px;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 28px;
            margin-bottom: 20px;
            white-space: normal;
            word-wrap: break-word;
            text-align: justify;
        }
        .txt_box1{
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 26px;
            text-align: justify;
        }
    }
    
}
.nametxt{
    max-width: 88px;
    max-height: 30px;
    margin: 0 auto;
    text-align: center;
    img{
        height: 30px;
        width: auto;
    }
}
.logoboxtxt{
    max-width: 240px;
    max-height: 84px;
    min-width: 240px;
    min-height: 84px;
    width: 240px;
    height: 84px;
    text-align: center;
    margin: 24px auto 0 auto;
    img{
        width: auto;
        height: 56px;
    }
}
</style>